export const faqs = [
  {
    q: '「美日吃瓜」主要关注哪些内容？',
    a: '我们聚焦美国与日本在文化层面的差异与摩擦，包括争议言论、网络骂战、价值观碰撞、政治正确与各类翻车现场。每个话题都会尽量补齐背景、双方立场和后续发展，让你在围观的同时看懂前因后果。',
  },
  {
    q: '站内的观点是否代表某一种立场？',
    a: '不代表。我们的原则是「先把两边的话都听完」。同一件事会尽量呈现当事人、围观者与旁观文化圈的不同解读，观点之间的冲突本身就是观察对象，而不是被我们直接判定的结论。',
  },
  {
    q: '为什么有些话题会反复出现在热榜里？',
    a: '跨文化摩擦往往不是孤立事件，而是结构性差异的重复显影。比如职场沟通、公共表达边界、道歉方式，这些问题会随着新的新闻不断以新面貌出现，所以我们也会持续回到同一批母题上。',
  },
  {
    q: '如何投稿或提供话题线索？',
    a: '你可以通过页面底部的联系方式给我们发邮件，附上事件链接、时间线和你的观察角度。我们更欢迎「带双方原始素材」的线索，这样整理出来的内容会更接近真实语境。',
  },
  {
    q: '内容可以转载或引用吗？',
    a: '站内内容欢迎在注明来源与原文链接的前提下合理引用。如果你需要整篇转载或有商业用途，请先通过邮件与我们沟通，我们会尽快回复。',
  },
  {
    q: '新手第一次来，应该从哪里开始看？',
    a: '建议先读首页的「本周精选」，再看「价值观碰撞」栏目。前者是当期最有代表性的案例，后者则提供了理解其他栏目的底层框架，看完之后再看争议言论和翻车现场会顺畅很多。',
  },
];